import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import ErrorBoundary from "@/components/ErrorBoundary";
import { ThemeProvider } from "@/contexts/ThemeContext";
import Import from "@/components/Import";
import DocumentUpload from "@/components/DocumentUpload";
import ExportActions from "@/components/ExportActions";
import { BatchExecutionDashboard } from "@/components/BatchExecutionDashboard";
import PrismCurrentDashboard, { PrismCurrentSourceGate } from "@/prism-v2/PrismCurrentDashboard";

import PrismBidirectionalCenter from "@/prism-v2/PrismBidirectionalCenter";
import PrismCorrelationMap from "@/prism-v2/PrismCorrelationMap";
import PrismProductShell from "@/prism-v2/PrismProductShell";

function DashboardPage() { return <PrismProductShell><PrismCurrentDashboard /></PrismProductShell>; }
function ControlRoomPage() { return <PrismProductShell><PrismCurrentSourceGate /></PrismProductShell>; }
function CorrelationMapPage() { return <PrismProductShell><PrismCorrelationMap /></PrismProductShell>; }
function BidirectionalCorePage() { return <PrismProductShell><PrismBidirectionalCenter /></PrismProductShell>; }
function PrismV2Page() { return <PrismProductShell><PrismCurrentSourceGate /></PrismProductShell>; }

function Router() {
  return (
    <Switch>
      <Route path="/" component={DashboardPage} />
      <Route path="/control-room" component={ControlRoomPage} />
      <Route path="/cases" component={PrismV2Page} />
      <Route path="/instance/:id" component={PrismV2Page} />
      <Route path="/correlation-map" component={CorrelationMapPage} />
      <Route path="/bidirectional-core" component={BidirectionalCorePage} />
      <Route path="/bidirectional" component={BidirectionalCorePage} />
      <Route path="/provenance" component={PrismV2Page} />
      <Route path="/export" component={PrismV2Page} />

      {/* Existing operational utilities remain available without becoming part of the primary Prism product shell. */}
      <Route path="/import" component={Import} />
      <Route path="/upload" component={DocumentUpload} />
      <Route path="/export-actions" component={ExportActions} />
      <Route path="/batch-execution" component={BatchExecutionDashboard} />
      <Route path="/404" component={NotFound} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="dark">
        <TooltipProvider>
          <Toaster />
          <Router />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
